import { g as __rest, b as __assign } from '../../../../tslib.es6-fe064bda.js';
import React__default from 'react';

var TabItem = function (_a) {
    var text = _a.text, _b = _a.className, className = _b === void 0 ? '' : _b, rest = __rest(_a, ["text", "className"]);
    return (React__default.createElement("div", __assign({ className: "view-select-tab ".concat(className), title: text }, rest),
        React__default.createElement("div", { className: 'view-select-tab-inner' },
            React__default.createElement("p", { className: 'view-select-tab-txt' }, text))));
};

export { TabItem };
